// Modulübergreifende Übergabe: eine Folge-Aktion (z.B. aus der Erfassung)
// wechselt das Modul und übergibt Vorbefüll-Daten. Ziel-Modul konsumiert
// die Payload beim Mount und leert den Store.

import { create } from 'zustand';
import type { ModuleKey } from '../components/layout/AppLayout';

/** Vorbefüllung eines Formulars aus einer erfassten Quelle. */
export interface FormularHandoff {
  action: 'formular';
  formularTyp: string;
  quelle: { datum?: string; text?: string; titel?: string };
}

/** Neuen Mandanten aus extrahierten Daten anlegen (Etappe B). */
export interface MandantHandoff {
  action: 'mandant';
  data: Record<string, unknown>;
}

/** Neuen Mitarbeiter aus extrahierten Daten anlegen (Etappe B2). */
export interface MitarbeiterHandoff {
  action: 'mitarbeiter';
  data: { vorname?: string; nachname?: string; geburtsdatum?: string };
}

/** Neue Begehung anlegen (aus Erfassung/Akte) — ersetzt das alte
 *  Begehungsprotokoll-Formular. */
export interface BegehungHandoff {
  action: 'begehung';
  quelle: { text?: string; titel?: string };
}

/** Besprechungsprotokoll zu einem Kalender-Termin öffnen/anlegen. */
export interface ProtokollHandoff {
  action: 'protokoll';
  event: { id: string; titel: string; datum: string; uhrzeit?: string; uhrzeit_ende?: string; ort?: string; notizen?: string };
}

export type HandoffPayload =
  | FormularHandoff | MandantHandoff | MitarbeiterHandoff | BegehungHandoff | ProtokollHandoff;

interface HandoffState {
  target: ModuleKey | null;
  payload: HandoffPayload | null;
  request: (target: ModuleKey, payload: HandoffPayload) => void;
  /** Payload abholen und Store leeren (idempotent). */
  consume: () => HandoffPayload | null;
}

export const useHandoffStore = create<HandoffState>((set, get) => ({
  target: null,
  payload: null,
  request: (target, payload) => { set({ target, payload }); },
  consume: () => {
    const { payload } = get();
    if (payload !== null) set({ target: null, payload: null });
    return payload;
  },
}));
